import React from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import noInvoiceImage from '@/images/no_location.png'

interface Props {
  children?: React.ReactNode
  text?: string
}

const EmptyBox: React.FC<Props> = ({ children, text = "Não há resultados para exibir" }) => {
  return (
    <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }} data-testid="empty-box">
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <CardMedia
          component="img"
          image={noInvoiceImage}
          sx={{ height: '250px', width: '250px', aspectRatio: '1 / 1' }}
        />
        <Typography variant='h5' color='text.primary'>{text}</Typography>
      </Box>
      <Box>
        {children}
      </Box>
    </Container>
  )
}

export default EmptyBox
